import { Component } from '@angular/core';

@Component({
  selector: 'tt-operation-equipments',
  templateUrl: './operation-equipments.component.html',
  styleUrls: ['./operation-equipments.component.css']
})
export class OperationEquipmentsComponent {

}
